var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { VERSION_URL } from '../../utils/common/apiConfig';
import httpGet from '../../utils/http/httpGet';
var fetchVersion = function (requestParameter, requestConfig) {
    if (requestParameter === void 0) { requestParameter = { t: Date.now().toString() }; }
    if (requestConfig === void 0) { requestConfig = {}; }
    var filledRequestConfig = __assign(__assign({}, requestConfig), { params: requestParameter });
    return httpGet("".concat(VERSION_URL, "?d=").concat(Date.now()), filledRequestConfig)
        .then(function (response) { return response; })
        .catch(function (e) {
        throw e;
    });
};
export default fetchVersion;
